// extracted by mini-css-extract-plugin
export default {"listElement":"ListElement_listElement__Fd9JY","alt":"ListElement_alt__Q5e9L"};